import { getBootstrapData } from '@experience/core-hostapp-share-lib';

export function useUnlicensedContentFilter() {
  const hideUnlicensed = computed(() => {
    return getBootstrapData().hideUnlicensedExperiencesForPartner;
  });

  return {
    hideUnlicensed,
  };
}
